import { useTranslation } from "react-i18next";
import { RelationModel } from "./RelationModel";

export const relationColumns = [
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    id: "street",
    header: "Address",
    accessorFn: (row: RelationModel) => {
      let address = `${row.street ?? ""} ${row.house_number ?? ""}${row.house_number_addition ? row.house_number_addition : ""}`;

      if (row.postal_code || row.city) {
        address += ", ";
      }

      address += `${row.postal_code ?? ""} ${row.city ?? ""}`;

      if (row.country) {
        address += ", ";
      }

      return `${address}${row.country ?? ""}`;
    },
  },
  {
    accessorKey: "status",
    header: "status",
    accessorFn: (row: RelationModel) => {
      const { t } = useTranslation("common");

      if (row.status) {
        return t("Active");
      }

      return t("Inactive");
    },
  },
];
